import { ShieldCheck } from "lucide-react";
import { renderAA } from "../aa";

// Concept 3 — Precision Bento Horizon
// Row of 4 pillar cards, a full-width FDE highlight bar, and a TRiSM trust strip.
export const ConceptBento = ({ core, fde, trism }) => (
  <div className="h-full w-full bg-[#F7F5F0] p-6 lg:p-8 flex flex-col" data-testid="concept-bento">
    <div className="mb-4">
      <span className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#8A5730]">The Platform</span>
      <h2 className="font-display text-2xl lg:text-3xl font-medium text-[#3E2818] tracking-tight mt-1 leading-tight">
        What It Takes to Achieve {renderAA("Agentic Alpha")}
      </h2>
    </div>

    <div className="flex-1 min-h-0 flex flex-col gap-3">
      {/* Pillars */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 flex-1 min-h-0">
        {core.map((c) => (
          <div
            key={c.title}
            className="group rounded-xl bg-white border border-[#3E2818]/10 p-4 flex flex-col min-h-0 overflow-hidden transition-all duration-300 hover:border-[#8A5730]/40 hover:shadow-[0_18px_44px_-26px_rgba(62,40,24,0.45)] hover:-translate-y-0.5"
            data-testid={`bento-pillar-${c.title}`}
          >
            <h3 className="font-display text-base lg:text-lg font-medium text-[#3E2818] leading-tight">{c.title}</h3>
            <p className="text-[11px] text-[#3E2818]/55 mt-1.5 leading-snug">{c.promise}</p>
            <div className="mt-auto space-y-1.5 pt-3 border-t border-[#3E2818]/8">
              {c.features.map((f) => (
                <div key={f.title} className="flex items-center gap-2 text-[11px] text-[#3E2818]/70">
                  <f.icon size={12} className="text-[#8A5730] shrink-0" strokeWidth={2} />
                  <span className="truncate">{f.title}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* FDE highlight bar */}
      <div className="rounded-xl bg-[#3E2818] text-[#F7F5F0] p-4 lg:p-5 flex flex-col lg:flex-row lg:items-center gap-3" data-testid="bento-fde">
        <div className="lg:w-[30%]">
          <span className="font-mono2 text-[9px] uppercase tracking-[0.2em] text-[#E8AA68]">AI Accelerator</span>
          <h3 className="font-display text-lg lg:text-xl font-medium leading-tight">{fde.title}</h3>
        </div>
        <div className="flex flex-wrap gap-2 lg:flex-1 lg:justify-end">
          {fde.features.map((f) => (
            <span key={f.title} className="flex items-center gap-1.5 text-[11px] px-3 py-1.5 rounded-full bg-white/10">
              <f.icon size={12} className="text-[#E8AA68]" strokeWidth={2} /> {f.title}
            </span>
          ))}
        </div>
      </div>

      {/* TRiSM trust strip */}
      <div className="rounded-xl border border-[#E8AA68]/70 bg-[rgba(232,170,104,0.07)] px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-2" data-testid="bento-trism">
        <div className="flex items-center gap-2 sm:w-1/4">
          <ShieldCheck size={15} className="text-[#8A5730]" />
          <span className="text-[13px] font-semibold text-[#3E2818]">{trism.title}</span>
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-1 sm:flex-1 sm:justify-end">
          {trism.features.map((f) => (
            <span key={f.title} className="flex items-center gap-1.5 text-[11px] text-[#8A5730]">
              <f.icon size={12} strokeWidth={2} /> {f.title}
            </span>
          ))}
        </div>
      </div>
    </div>
  </div>
);
